import { render, staticRenderFns } from "./OrganizationAIManagers.vue?vue&type=template&id=58e75fc6"
import script from "./OrganizationAIManagers.vue?vue&type=script&lang=js"
export * from "./OrganizationAIManagers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports